import { render, staticRenderFns } from "./Upcoming.vue?vue&type=template&id=197d8e80&scoped=true&"
import script from "./Upcoming.vue?vue&type=script&lang=js&"
export * from "./Upcoming.vue?vue&type=script&lang=js&"
import style0 from "./Upcoming.vue?vue&type=style&index=0&id=197d8e80&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197d8e80",
  null
  
)

export default component.exports